import React, { Component } from "react";
import tipos from "./tipos";

class TableSubData extends Component {
    monetaryFormat = (value) => {
        let doubleFormatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maximumFractionDigits: 0,
        });
        return doubleFormatter.format(value);
    };

    areaFormat = (value) => {
        let doubleFormatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            maximumFractionDigits: 2,
        });
        return doubleFormatter.format(value);
    };

    render() {
        let { data, tipoLabel, tipoCampo, totalTipo, countBuildings } = this.props;

        if (!data || data.length === 0) {
            return null;
        }

        if (tipoLabel == "Padrão") {
            const ordemPadrao = tipos.select_padroes.map(item => item.value);
            data = [...data].sort((a, b) => ordemPadrao.indexOf(a.padrao) - ordemPadrao.indexOf(b.padrao));
        }

        return (
            <div style={{ marginBottom: "20px" }}>
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>{tipoLabel}</th>
                            <th>Nº Imóveis</th>
                            <th>% Sobre {this.props.tipo}</th>
                            <th>% Sobre Total</th>
                            <th>Área Média Total</th>
                            <th>Área Média Útil</th>
                            <th>Preço Médio</th>
                            <th>Preço Médio M²</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, i) => (
                            <tr key={i}>
                                <td>{item[tipoCampo]}</td>
                                <td>{item.total.toLocaleString("pt-BR")}</td>
                                <td>
                                    {Number((item.total * 100) / totalTipo)
                                        .toFixed(2)
                                        .toLocaleString()
                                        .replace(".", ",")}%
                                </td>
                                <td>
                                    {Number((item.total * 100) / countBuildings)
                                        .toFixed(2)
                                        .toLocaleString()
                                        .replace(".", ",")}%
                                </td>
                                <td>{this.areaFormat(item.media_area_total)}</td>
                                <td>{this.areaFormat(item.media_area_util)}</td>
                                <td>{this.monetaryFormat(item.media_preco)}</td>
                                <td>{this.monetaryFormat(item.media_preco_metro)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default TableSubData;
